module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.9463/images/checkmark-circle.svg"